import React from 'react';
import PropTypes from 'prop-types';
import round from '../../../helpers/round';
import f1Grapgh from '../../../assets/calculations/stroud/f1.JPG';

const GRAPH_WIDTH = 300;
const f1Image = { width: 567, height: 423 };

// Calibrated from debug points (PI 20-60)
// Quadratic x mapping (fits PI 20-60 precisely)
const F1_X_A = -0.000071428571426;
const F1_X_B = 3.378714285714;
const F1_X_C = 47.34;
const F1_Y_SLOPE = -17.650566;
const F1_Y_INTERCEPT = 185.385378;

const buildF1Graph = (pi, f1) => {
  const height = (GRAPH_WIDTH * f1Image.height) / f1Image.width;
  const baseX = F1_X_A * pi * pi + F1_X_B * pi + F1_X_C;
  const verticalX =
    pi >= 15 && pi <= 30
      ? baseX + 1
      : pi > 30 && pi <= 45
        ? baseX + 2
        : pi > 45 && pi <= 70
          ? baseX + 4
          : baseX;
  const y = F1_Y_INTERCEPT + F1_Y_SLOPE * f1;

  return {
    width: GRAPH_WIDTH,
    height,
    x: baseX,
    verticalX,
    verticalTopY: y,
    verticalBottomY: F1_Y_INTERCEPT,
    horizontalY: y,
    horizontalX1: F1_X_C,
    horizontalX2: baseX,
    labelX: F1_X_C + 2,
    labelY: y - 5,
  };
};

const StroudF1GraphSvg = ({ pi, f1, showOverlay }) => {
  const piValue = Number(pi);
  const f1Value = Number(f1);
  const graph = buildF1Graph(piValue, f1Value);

  return (
    <svg
      width="100%"
      height="100%"
      viewBox={`0 0 ${graph.width} ${graph.height}`}
      preserveAspectRatio="xMidYMid meet"
      role="img"
      aria-label="Stroud f1 correlation graph"
      style={{ display: 'block', width: '100%', height: 'auto', aspectRatio: `${graph.width} / ${graph.height}` }}
    >
      <image href={f1Grapgh} x="0" y="0" width={graph.width} height={graph.height} />
      {showOverlay && (
        <g stroke="#b33a3a" fill="none" strokeWidth="2" vectorEffect="non-scaling-stroke">
          <line x1={graph.verticalX} y1={graph.verticalTopY} x2={graph.verticalX} y2={graph.verticalBottomY} />
          <polyline
            points={`${graph.verticalX - 3},${graph.verticalTopY + 5} ${graph.verticalX},${graph.verticalTopY} ${graph.verticalX + 3},${graph.verticalTopY + 5}`}
          />
          <line x1={graph.horizontalX1} y1={graph.horizontalY} x2={graph.horizontalX2} y2={graph.horizontalY} />
          <polyline
            points={`${graph.horizontalX1 + 6},${graph.horizontalY - 3} ${graph.horizontalX1 + 1},${graph.horizontalY} ${graph.horizontalX1 + 6},${graph.horizontalY + 3}`}
          />
        </g>
      )}
      {showOverlay && (
        <text x={graph.labelX} y={graph.labelY - 2} fill="#b33a3a" fontSize="9" fontWeight="700">
          f<tspan baselineShift="sub" fontSize="7">1</tspan>={round(f1Value, 2)}
        </text>
      )}
    </svg>
  );
};

StroudF1GraphSvg.propTypes = {
  pi: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  f1: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  showOverlay: PropTypes.bool,
};

StroudF1GraphSvg.defaultProps = {
  showOverlay: false,
};

export default React.memo(StroudF1GraphSvg);
